import { render } from "./TermsOfUse.vue?vue&type=template&id=6f039b60&scoped=true&ts=true"
import script from "./TermsOfUse.vue?vue&type=script&lang=ts"
export * from "./TermsOfUse.vue?vue&type=script&lang=ts"

import "./TermsOfUse.vue?vue&type=style&index=0&id=6f039b60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f039b60"]])

export default __exports__